export default "__VITE_PUBLIC_ASSET__a8f94b97__"